<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium"
          @keyup.enter.native.prevent="doQueryTable">
          <el-form-item label="客户：">
            <el-select filterable v-model="searchForm.TC_COMPANY" placeholder="请选择客户" :clearable="true"
              @change="filterProjects">
              <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select filterable v-model="searchForm.project" placeholder="请选择项目点" @change="querydkList"
              :clearable="true">
              <el-option v-for="item in allProjects" :key="item.PROJECT_ID" :label="item.PROJECT_NAME"
                :value="item.PROJECT_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="档口：">
            <el-select filterable v-model="searchForm.dkName" placeholder="请选择档口" clearable>
              <el-option v-for="item in dk_List" :key="item.ID" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID：">
            <el-input v-model="searchForm.ORDER_ID" clearable oninput='value=value.replace(/[^0-9]/g,"")'></el-input>
          </el-form-item>
          <el-form-item label="送货日期：">
            <el-date-picker v-model="searchForm.SEND_DAY" type="date" placeholder="请选择送货日期" :clearable="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单备注：">
            <el-input v-model="searchForm.ORDER_LIST_COMMENT" placeholder="请输入订单备注" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doQueryTable" :loading="loadSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="entryOrder">手动录入</el-button>
        <el-button size="medium" @click="bulkLaunchAllOrder">批量发起</el-button>
        <el-button size="medium" @click="exportEnterOrder(0)">导入订单（LKD编码）</el-button>
        <el-button size="medium" @click="exportEnterOrder(1)">导入订单（客户编码）</el-button>
        <el-button size="medium" @click="exportPriceOrder(0)" v-if="userPriceType == 1">带价格导入订单（LKD编码）</el-button>
        <el-button size="medium" @click="exportPriceOrder(1)" v-if="userPriceType == 1">带价格导入订单（客户编码）</el-button>
        <el-button size="medium" @click="exportPriceOrderNoGoods" v-if="userPriceType == 1">
          带价格导入订单（LKD编码不合并商品）
        </el-button>
        <el-button size="medium" type="primary" plain @click="打开一键导出模态框()">一键导出订单</el-button>
        <tooltip-button :disabled="Boolean(checkedArray.length)" buttonText="发起到出库" tipContent="请先勾选订单"
          @click="launchToDelivery" v-if="fun_dic[100000002]" />
        <el-button size="medium" @click="importGHOrder" v-if="fun_dic[100000003]">导入订单（高后订单）</el-button>
        <el-button size="medium" @click="批量删除()" v-if="fun_dic[100000004]">批量删除</el-button>
        <el-button size="medium" @click="importOrderWithProductInfo()" v-if="fun_dic[100000006]">导入订单(商品信息)</el-button>
        <el-button size="medium" v-if="fun_dic[100000007]" @click="复制虚拟订单()">复制虚拟订单</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="选择订单信息" center :visible.sync="addFormVisible" width="600px">
          <el-form :model="addForm" ref="addForm" size="small">
            <el-form-item label="客户名称：">
              <el-select filterable v-model="addForm.customer" style="width:80%" @change="queryProject($event)">
                <el-option v-for="item in customers" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目点：">
              <label slot="label">项&nbsp;目&nbsp;&nbsp;点：</label>
              <el-select filterable v-model="addForm.project" style="width:80%" @change="queryDK($event)">
                <el-option v-for="item in projects" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="档口：">
              <label slot="label">档&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;口：</label>
              <el-select filterable v-model="addForm.dkId" style="width:80%">
                <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="送货日期：">
              <el-date-picker v-model="addForm.SEND_DAY" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                style="width:80%" @change="chooseDate">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="订单备注：" v-if="flag === 0">
              <el-input v-model="addForm.COMMENT" placeholder="请输入订单备注" clearable style="width:80%"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitAdd" :disabled="!addForm.dkId">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border show-summary :summary-method="getSummaries"
          style="width: 100%;margin-top:20px" @selection-change="handleSelectionChange"
          :row-class-name="getTableRowClass">
          <el-table-column type="selection" width="60" label="序号"></el-table-column>
          <el-table-column prop="ORDER_ID" label="订单ID" min-width="100"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编号" min-width="230"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="135"></el-table-column>
          <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口" min-width="150"></el-table-column>
          <el-table-column prop="TOTAL_SUPPLIER_FEE" label="总价（元）" min-width="100"></el-table-column>
          <el-table-column prop="COUNT" label="单品数量" min-width="100"></el-table-column>
          <el-table-column prop="ORDER_LIST_COMMENT" label="订单备注" min-width="100"></el-table-column>
          <el-table-column prop="PRINT_TIME" label="打印次数" min-width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" width="345">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="submitPrint(scope.row)">打印</el-button>
              <el-button type="text" size="small" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="copyOrder(scope.row)">复制</el-button>
              <el-button type="text" size="small" @click="createOrder(scope.row)">快捷创建</el-button>
              <el-button type="text" size="small" @click="oneButton(scope.row)" v-show="scope.row.SUPPLIER_STATUS == 0">
                一键转换
              </el-button>
              <el-button type="text" size="small" @click="output(scope.row, 0)">导出</el-button>
              <el-button type="text" size="small" @click="output(scope.row, 1)">按录入顺序导出</el-button>
              <el-button type="text" size="small" @click="deleteOrder(scope.row)" style="color:#F56C6C">删除</el-button>
              <el-button type="text" size="small" @click="exportCheck(scope.row)">检验报告</el-button>
              <el-button type="text" size="small" @click="editDate(scope.row)">修改日期</el-button>
              <el-button type="text" size="small" @click="launchOrder(scope.row)">发起</el-button>
              <el-button type="text" size="small" @click="printBySequence(scope.row)" v-if="fun_dic[100000001]">
                按录单顺序打印
              </el-button>
              <el-button type="text" size="small" v-if="Number(scope.row.TC_STATUS) == 2 && fun_dic[100000005]"
                @click="修改客户(scope.row)">
                修改客户
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 一键转换 -->
    <el-row>
      <el-col>
        <el-dialog title="选择订单信息" center :visible.sync="oneButVisible" width="600px">
          <el-form size="small" :model="oneForm" ref="oneForm">
            <el-form-item label="送货日期：" :label-width="formLableWidth">
              <el-date-picker v-model="oneForm.SEND_DAY" clearable type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd" style="width:80%"></el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer" class=" ">
            <el-button size="small" @click="oneButVisible = false">取 消</el-button>
            <el-button size="small" @click="oneButSubmit">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <!-- 导入订单 -->
    <el-dialog :visible.sync="exportOrderDialog" title="导入订单" width="400px" center>
      <el-form ref="orderForm" v-model="orderForm">
        <el-upload class="upload-demo" ref="upload" action="/uploadFile" :on-remove="handleRemove" :on-success="handleSuccess"
          :name="orderForm.orderName" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downLoadOrder" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
        <p style="color: red">您当前使用的产品单位是{{ isUseKG == 1 ? '公斤' : '斤' }}</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="exportOrderDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleExportOrder">确认</el-button>
      </div>
    </el-dialog>
    <!-- 导入订单 -->
    <el-dialog :visible.sync="exportPriceOrderDialog" title="导入订单" width="400px" center>
      <el-form ref="priceOrderForm" v-model="priceOrderForm">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove" :on-success="handleSuccess"
          :name="this.priceOrderForm.orderName" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downPriceOrder" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
        <p style="color: red">您当前使用的产品单位是{{ isUseKG == 1 ? '公斤' : '斤' }}</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="exportPriceOrderDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handlePriceOrder">确认</el-button>
      </div>
    </el-dialog>
    <!-- 不合并商品 -->
    <el-dialog :visible.sync="exportPriceOrderNoGoodsDialog" title="导入订单不合并商品" width="400px" center>
      <el-form ref="priceOrderNoGoodsForm" v-model="priceOrderNoGoodsForm">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove" :on-success="handleSuccess"
          :name="priceOrderNoGoodsForm.orderName" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <p @click="downPriceOrder" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p style="color: red">您当前使用的产品单位是{{ isUseKG == 1 ? '公斤' : '斤' }}</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="exportPriceOrderNoGoodsDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handlePriceOrderNoGoods">确认</el-button>
      </div>
    </el-dialog>
    <!-- 修改订单日期 -->
    <el-dialog title="修改订单日期" center :visible.sync="editDateVisible" width="600px">
      <el-form size="small" :model="editDateForm" ref="oneForm">
        <el-form-item label="订单日期：" :label-width="formLableWidth">
          <el-date-picker v-model="editDateForm.SEND_DAY" clearable type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd" style="width:80%"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class=" ">
        <el-button size="small" @click="editDateVisible = false">取 消</el-button>
        <el-button size="small" @click="editDateSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 抬头打印 -->
    <el-dialog title="抬头信息" center :visible.sync="payableFormVisible" width="400px">
      <el-form :model="payableForm" ref="payableForm" label-width="100px">
        <el-form-item label="打印类型：">
          <el-radio v-model="payableForm.TYPE" label="1">短打印</el-radio>
          <el-radio v-model="payableForm.TYPE" label="2">长打印</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="payableFormVisible = false">取 消</el-button>
        <el-button @click="submitPayable">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导出样式" center :visible.sync="一键导出模态框" width="400px">
      <el-form :model="一键导出表单" ref="一键导出表单">
        <el-form-item label="打印类型：" label-width="100px">
          <el-radio v-model="一键导出表单.选择类型" label="0">编码顺序</el-radio>
          <el-radio v-model="一键导出表单.选择类型" label="1">下单顺序</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="一键导出模态框 = false">取 消</el-button>
        <el-button @click="exportallOrder">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 沛锦导入高后订单 -->
    <el-dialog :visible.sync="importGHOrderDialog" title="导入订单" width="400px" center>
      <el-form>
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove" :on-success="handleSuccess" name="tmp" :limit="1"
          accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downloadGHOrder" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
        <p style="color: red">您当前使用的产品单位是{{ isUseKG == 1 ? '公斤' : '斤' }}</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="importGHOrderDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleGHOrder">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="发起到出库" center :visible.sync="deliveryDialog" top="2vh" width="90%" :close-on-click-modal="false">
      <el-collapse v-model="deliveryCollapse" style="max-height: 75vh; overflow: auto;">
        <el-collapse-item v-for="(item, index) in deliveryList" :key="item.ORDER_ID" :title="item.TITLE" :name="index">
          <el-table ref="table" :data="item.LIST" :span-method="(options) => objectSpanMethod(options, index)"
            class="tableArea" style="width: 100%" border :cell-style="setOutBackgroundColor">
            <el-table-column prop="ID" label="序号" width="50">
              <template slot-scope="scope">
                <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
                  {{ scope.row.ID }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="NAME" label="名称">
              <template slot-scope="scope">
                <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
                  {{ scope.row.NAME }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位">
              <template slot-scope="scope">
                <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
                  {{ scope.row.TYPE_UNIT }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="NEED_COUNT" label="所需总数">
              <template slot-scope="scope">
                <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
                  {{ scope.row.NEED_COUNT }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="PRODUCT_COMMENT" label="备注">
              <template slot-scope="scope">
                <span :style="$_setFontColor(scope.row.ENOUGH_FLAG)">
                  {{ scope.row.PRODUCT_COMMENT }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="可出库产品">
              <el-table-column prop="WAREHOUSE_PRODUCT_NAME" label="产品名称"></el-table-column>
              <el-table-column prop="NEW_TYPE_UNIT" label="单位"></el-table-column>
              <el-table-column prop="PRODUCT_PRICE" label="单价"></el-table-column>
              <el-table-column prop="BATCH" label="批次"></el-table-column>
              <el-table-column prop="PRODUCTION_DATE" label="生产日期"></el-table-column>
              <el-table-column label="保质期">
                <template slot-scope="scope">
                  <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="INW_COUNT" label="库存数量"></el-table-column>
              <el-table-column prop="LOCATION_CODE" label="库位" v-if="WAREHOUSE_MODE == 2"></el-table-column>
              <el-table-column prop="LACK_COUNT" label="出库数量" width="200">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.LACK_COUNT" :placeholder="scope.row.PLACE_LACK_COUNT"
                    @blur="onDeliveryBlur(scope.row)">
                  </el-input>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <template v-if="overList.length">
          <h2>各订单总出库数量超出库存的产品:</h2>
          <el-table :data="overList" style="width: 100%" border>
            <el-table-column prop="WAREHOUSE_PRODUCT_NAME" label="产品名称"></el-table-column>
            <el-table-column prop="BATCH" label="批次"></el-table-column>
            <el-table-column prop="PRODUCTION_DATE" label="生产日期"></el-table-column>
            <el-table-column prop="LOCATION_CODE" label="库位"></el-table-column>
          </el-table>
        </template>
      </el-collapse>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="deliveryDialog = false">取 消</el-button>
        <el-button size="small" @click="submitLaunchToDelivery">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="缺货采购" center :visible.sync="outOfStockDialog" top="0" width="90%" :close-on-click-modal="false">
      <el-collapse v-model="purchaseCollapse">
        <el-collapse-item v-for="(item, index) in outOfStockList" :key="item.SALES_SEND_DATE"
          :title="`销售订单送货日期：${item.SALES_SEND_DATE}`" :name="index">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="采购送货日期：">
              <el-date-picker v-model="item.SEND_DATE" type="date" value-format="yyyy-MM-dd" placeholder="请选择送货日期"
                :clearable="false">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <el-table ref="table" :data="item.LIST" style="width: 100%" border :cell-style="setOutBackgroundColor">
            <el-table-column prop="ID" label="序号" width="50"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="PURCHASE_COUNT" label="采购数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.PURCHASE_COUNT" @blur="onPurchaseCountBlur(scope.row)" clearable>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="PRICE" label="单价">
              <template slot-scope="scope">
                <el-input v-model="scope.row.PRICE" @blur="onPurchasePriceBlur(scope.row)" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="SUPPLIER_ID" label="供应商">
              <template slot-scope="scope">
                <el-select filterable v-model="scope.row.SUPPLIER_ID" @change="getPurchasePrice(scope.row)">
                  <el-option v-for="item in oneCustomers" :key="item.SUPPLIER_ID"
                    :label="item.SUPPLIER_ID ? item.NAME : ''" :value="item.SUPPLIER_ID">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="outOfStockDialog = false">取 消</el-button>
        <el-button size="small" @click="submitPurchase">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="修改客户模态框" title="修改客户" width="500px" center>
      <el-form size="medium" :model="修改客户表单" ref="修改客户表单" :inline="true">
        <el-form-item label="客户：" label-width='120px'>
          <el-select @change="(e) => { 修改客户拉取项目点(e) }" style="width: 300px" filterable v-model="修改客户表单.TC_ID"
            placeholder="请选择客户">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：" label-width='120px'>
          <el-select @change="(e) => { 修改项目点拉取档口(e) }" style="width: 300px" filterable v-model="修改客户表单.PROJECT_ID"
            placeholder="请选择项目点">
            <el-option v-for="item in 修改客户用项目点列表" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口：" label-width='120px'>
          <el-select style="width: 300px" filterable v-model="修改客户表单.DK_ID" placeholder="请选择档口">
            <el-option v-for="item in 修改客户用档口列表" :key="item.ID" :label="item.NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="修改客户模态框 = false">取 消</el-button>
        <el-button size="small" @click="确认修改客户()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="productionDateDialog" title="选择生产日期" width="500px" center
      @close="$refs.productionDateForm.resetFields()">
      <el-form size="medium" :model="productionDateForm" ref="productionDateForm" label-width='120px'>
        <el-form-item label="生产日期：">
          <el-date-picker v-model="productionDateForm.PRODUCTION_DATE" type="date" value-format="yyyy-MM-dd"
            placeholder="请选择生产日期" clearable>
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="productionDateDialog = false">取 消</el-button>
        <el-button size="small" @click="confirmProductionDate">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="importOrderWithProductInfoDialog" title="导入订单(商品信息)" width="400px" center
      @close="closeImportOrderWithProductInfo">
      <el-form ref="importOrderWithProductInfoForm" :model="importOrderWithProductInfoForm"
        :rules="importOrderWithProductInfoRules">
        <el-form-item prop="fileList">
          <el-upload class="upload-demo" ref="upload" action="/uploadFile" v-model="importOrderWithProductInfoForm.fileList"
            :on-remove="$util.handleUploadRemove.bind(this, 'importOrderWithProductInfoForm', 'fileList')"
            :on-success="$util.handleUploadSuccess.bind(this, 'importOrderWithProductInfoForm', 'fileList')"
            :name="importOrderWithProductInfoForm.name" :limit="1" accept=".xls,.xlsx"
            :file-list="importOrderWithProductInfoForm.fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <p @click="downloadImportOrderWithProductInfoTemplate"
            style="color: #409EFF;margin-top: 20px;cursor: pointer">
            点击下载导入模板</p>
        </el-form-item>
        <el-form-item prop="SEND_DAY" label="送货日期：">
          <el-date-picker v-model="importOrderWithProductInfoForm.SEND_DAY" type="date" value-format="yyyy-MM-dd"
            placeholder="请选择送货日期" :clearable="true">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="closeImportOrderWithProductInfo">取消</el-button>
        <el-button class="operate-btn" @click="submitImportOrderWithProductInfo">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  addOrderFun,
  selectProjectFun,
  selectDKFun,
  getEnteyCusFun,
  chooseTCFun,
  copyOrderFun,
  exportSellOrder,
  exportCheckFun,
  exportPriceOrder,
  deleteOrderFun,
  printOrderFun,
  haveGYSFun,
  oneGYSFun,
  bulkLaunch,
  haveXMDFun,
  editDate,
  getHaveSupplyRelationshipProjectList,
} from 'api/sellOrder';
import { unitManageFun } from 'api/systemSetting';
import date from '@/assets/common/date';
import { getFormatDay } from '@/assets/common/common';
import http from '@/assets/common/http';
import util from '@/assets/common/util';
import { getActionFun } from '@/assets/api/login';
import { setOutFontColor, stockOutDetailFun } from '@/assets/api/warehouseManager';
import { showFullScreenLoading, tryHideFullScreenLoading } from '@/assets/plugin/loading/loading';
import validation from '@/assets/common/validation';

export default {
  data () {
    return {
      PAGE_ID: '1000000', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        100000001: 0, 100000002: 0, 100000003: 0, 100000004: 0, 100000005: 0, 100000006: 0, 100000007: 0,
      },
      一键导出表单: {
        选择类型: '1',
      },
      loadSearch: false,
      addFormVisible: false,
      exportPriceOrderNoGoodsDialog: false,
      exportPriceOrderDialog: false,
      exportPriceFlag: 0,
      addForm: {
        customer: '',
        project: '',
        dkId: '',
        SEND_DAY: '',
      },
      exportOrderDialog: false,
      orderForm: {
        orderName: 'tmp',
      },
      fileList: [],
      file_name: '',
      customers: [],
      dk_List: [],
      oneForm: {
        oneCustomer: '',
        SEND_DAY: new Date(),
      },
      editDateVisible: false,
      editDateForm: {
        SEND_DAY: '',
      },
      sendDate: '',
      orderId: '',
      ORDER_CODE: '',
      priceOrderForm: {
        orderName: 'tmp',
      },
      priceOrderNoGoodsForm: {
        orderName: 'tmp',
      },
      oneCustomers: [],
      oneButVisible: false,
      projects: [],
      formLableWidth: '120px',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      companys: [],
      pickerOptions2: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      exportFlag: 0,
      flag: '',
      dkList: [],
      nameForm: {
        companyName: '',
      },
      一键导出模态框: false,
      nameFormVisible: false,
      oneOrderId: '',
      tableData: [],
      searchForm: { DAY_INTERVAL: [], dkName: '' },
      checkedArray: [],
      tmpOrderId: [],
      submitArr: [],
      allProjects: [],
      allProjectsCopy: [],
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      isUseKG: sessionStorage.getItem('IS_USE_KG'),
      payableFormVisible: false,
      payableForm: {
        TYPE: '1',
      },
      deliveryList: [],
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
      deliveryDialog: false,
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      spanArr: [],
      deliveryCollapse: [],
      outOfStockList: [],
      outOfStockDialog: false,
      purchaseCollapse: [],
      tempObj: {},
      notEnoughList: [],
      overList: [],
      importGHOrderDialog: false,
      修改客户模态框: false,
      修改客户表单: {},
      修改客户用项目点列表: [],
      修改客户用档口列表: [],
      productionDateDialog: false,
      productionDateForm: {
        PRODUCTION_DATE: '',
      },
      importOrderWithProductInfoDialog: false,
      importOrderWithProductInfoForm: {
        name: 'exportOut',
        fileList: [],
        SEND_DAY: '',
      },
      importOrderWithProductInfoRules: {
        SEND_DAY: [{
          required: true, message: '请选择送货日期', trigger: 'change',
        }],
        fileList: [{
          required: true, message: '请上传文件', trigger: 'change',
        }],
      },
    };
  },
  created () {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;

    if (JSON.parse(sessionStorage.getItem('searchForm'))) {
      this.searchForm = JSON.parse(sessionStorage.getItem('searchForm'));
      sessionStorage.removeItem('searchForm');
    }
    if (JSON.parse(sessionStorage.getItem('tableData'))) {
      this.tableData = JSON.parse(sessionStorage.getItem('tableData'));
      sessionStorage.removeItem('tableData');
    }

    if (this.ENTRY_SEARCH_DATA_CONDITION.CONDITION) {
      this.searchForm = this.ENTRY_SEARCH_DATA_CONDITION.CONDITION;
      this.currentPage = this.ENTRY_SEARCH_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryBeforeFun();
    this.queryCustomer();
    this.getDate();
    this.queryTable();
    this.queryOneGYSData();
    this.queryAllProject();
  },
  computed: {
    ENTRY_SEARCH_DATA_CONDITION () {
      return this.$store.state.ENTRY_SEARCH_DATA_CONDITION;
    },

  },
  methods: {
    复制虚拟订单 () {
      this.$router.push({ name: 'copyVirtualOrder' });
    },
    确认修改客户 () {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 103,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: this.修改客户表单.ORDER_ID,
        TC_ID: this.修改客户表单.TC_ID,
        PROJECT_ID: this.修改客户表单.PROJECT_ID,
        STALL_ID: this.修改客户表单.DK_ID,
      };
      http.post(params).then((res) => {
        this.queryTable();
        this.$message.show({ text: '修改成功', type: 'success' });
        this.修改客户表单 = {};
        this.修改客户模态框 = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    修改项目点拉取档口 (e) {
      if (!this.修改客户表单.PROJECT_ID) {
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: e,
      };
      http.post(params).then((result) => {
        this.修改客户用档口列表 = result;
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    修改客户拉取项目点 (e) {
      if (!this.修改客户表单.TC_ID) {
        return false;
      }
      this.修改客户表单.PROJECT_ID = '';
      const params = {
        TC_ID: e,
      };
      getHaveSupplyRelationshipProjectList(params).then((result) => {
        if (result[0]) {
          this.修改客户用项目点列表 = result;
        } else {
          this.修改客户用项目点列表 = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    修改客户 (row) {
      this.修改客户模态框 = true;
      this.修改客户表单.ORDER_ID = row.ORDER_ID;
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (['TOTAL_SUPPLIER_FEE', 'COUNT'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + Math.floor((value) * 100) / 100;
            }
            return prev;
          }, 0).toFixed(2);
          if (column.property == 'COUNT') sums[index] = Number(sums[index]);
        }
      });
      this.sums = sums;
      return sums;
    },
    // 导入订单
    exportEnterOrder (e) {
      this.exportOrderDialog = true;
      this.exportFlag = e;
    },
    handleSuccess (response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove (file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    handleExportOrder () {
      if (this.file_name) {
        const params = {
          FILE_NAME: this.file_name,
          STATUS: -1,
          PRICE_MODE: this.userPriceType,
        };
        if (this.exportFlag == 1) {
          params.USE_TC_PRODUCT_CODE = 1;
        }
        exportSellOrder(params).then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            this.exportOrderDialog = false;
            this.queryTable();
          } else {
            this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'warning' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
        });
      } else {
        this.$message.show({ text: '请点击上传文件', type: 'warning' });
      }
    },
    downLoadOrder () {
      window.location.href = 'https://service.linkda.com.cn/file/templates/smpsaleordertemp.xls';
    },
    downPriceOrder () {
      window.location.href = 'https://service.linkda.com.cn/file/templates/smpsaleorderwithpricetemp.xls';
    },
    exportPriceOrder (flag) {
      this.exportPriceOrderDialog = true;
      this.exportPriceFlag = flag;
    },
    handlePriceOrder () {
      if (this.file_name) {
        const params = {
          FILE_NAME: this.file_name,
          STATUS: -1,
        };
        if (this.exportPriceFlag == 1) {
          params.USE_TC_PRODUCT_CODE = 1;
        }
        exportPriceOrder(params)
          .then((result) => {
            if (result[0].FILE_PATH == '') {
              this.$message.show({ text: '导入成功', type: 'success' });
              this.file_name = '';
              this.$refs.upload.clearFiles();
              this.exportPriceOrderDialog = false;
              this.queryTable();
            } else {
              this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'error' });
              this.file_name = '';
              this.$refs.upload.clearFiles();
              window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
          });
      } else {
        this.$message.show({ text: '请点击上传文件', type: 'warning' });
      }
    },
    exportPriceOrderNoGoods () {
      this.exportPriceOrderNoGoodsDialog = true;
    },
    handlePriceOrderNoGoods () {
      if (this.file_name) {
        const params = {
          FILE_NAME: this.file_name,
          SERVICE_ID: '10004',
          OTYPE: 31,
          MERGE_ORDER_DETAIL: 0,
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          STATUS: -1,
        };
        http.post(params).then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            this.exportPriceOrderNoGoodsDialog = false;
            this.queryTable();
          } else {
            this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
        });
      } else {
        this.$message.show({ text: '请点击上传文件', type: 'warning' });
      }
    },
    // ----------------------------一键转化
    oneButton (row) {
      this.oneButVisible = true;
      this.oneOrderId = row.ORDER_ID;
    },
    // -------------------------------------一键转换供应商
    queryOneGYSData () {
      const params = {};
      haveGYSFun(params).then((result) => {
        if (result.length !== 0) {
          this.oneCustomers = result[0].list;
        } else {
          this.oneCustomers = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------一键转换确认
    oneButSubmit () {
      // 关账限制
      if (this.$util.isOrderClosed(this.oneForm.SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法转换订单', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: Number(this.oneOrderId),
            SEND_DAY: date(this.oneForm.SEND_DAY, '%F'),
          };
          oneGYSFun(params).then((result) => {
            this.oneButVisible = false;
            this.$message.show({ text: '操作成功', type: 'success' });
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    close () {
      this.addFormVisible = false;
      this.addForm = {};
    },
    entryOrder () {
      this.addFormVisible = true;
      this.flag = 0;
      this.addForm.SEND_DAY = getFormatDay(1, '-');
    },
    createOrder (row) {
      this.flag = 0;
      this.queryCustomer();
      this.addForm.customer = row.TC_ID;
      if (row.TC_ID) {
        this.queryProject(row.TC_ID);
        this.addForm.project = row.PROJECT_ID;
      }
      if (row.PROJECT_ID) {
        this.queryDK(row.PROJECT_ID);
        this.addForm.dkId = row.DK_ID;
      }
      if (row.DK_ID) {
        this.changeDK(row.DK_ID);
      }
      if (row.SEND_DAY) {
        this.addForm.SEND_DAY = row.SEND_DAY;
      }
      this.addFormVisible = true;
    },
    changeDK (event) {
      for (let i = 0; i < this.dkList.length; i++) {
        if (event === this.dkList[i].ID) {
          sessionStorage.setItem('DK_NAME', this.dkList[i].NAME);
        }
      }
    },
    copyOrder (row) {
      this.addFormVisible = true;
      this.flag = 1;
      this.addForm = {};
      this.addForm.ORDER_ID = row.ORDER_ID;
    },
    // 获取设置--销售录单是否校验重复备注
    queryIsSimiliarOrder () {
      return new Promise((resolve, reject) => {
        unitManageFun().then((result) => {
          resolve(result[0].IS_SIMILIAR_ORDER);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          reject(Error('未正确获取到属性IS_SIMILIAR_ORDER'));
        });
      });
    },
    // 查询订单备注是否重复
    queryIsRepeatComment () {
      return new Promise((resolve, reject) => {
        const params = {
          SERVICE_ID: '10004',
          OTYPE: 100,
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          SEND_DAY: date(this.addForm.SEND_DAY, '%F'),
          DK_ID: this.addForm.dkId,
          COMMENT: this.addForm.COMMENT,
        };
        http.post(params).then((result) => {
          if (JSON.stringify(result) === '[]') {
            resolve(1);
          } else {
            resolve(0);
          }
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
          reject(Error('未正确获取到属性IsRepeatComment'));
        });
      });
    },
    // ----------------------------------确认按钮
    async submitAdd () {
      if (!this.addForm.SEND_DAY || !this.addForm.customer || !this.addForm.project || !this.addForm.dkId) {
        this.$message.show({ text: '请选择客户名称、项目点、档口和送货日期', type: 'warning' });
        return false;
      }
      // 关账限制
      if (this.$util.isOrderClosed(this.addForm.SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法下单', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          // ----------------------------手动录入
          if (this.flag === 0) {
            const IS_SIMILIAR_ORDER = await this.queryIsSimiliarOrder();
            if (IS_SIMILIAR_ORDER === 1 && this.addForm.COMMENT) {
              const IsRepeatComment = await this.queryIsRepeatComment();
              if (IsRepeatComment === 0) {
                let passFlag = false;
                await this.$confirm('当天存在相同备注订单，是否再次创建订单?', '提示', {
                  confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true,
                }).then(() => {
                  passFlag = true;
                }).catch((action) => {
                  if (action === 'cancel') {
                    document.body.style.cursor = 'default';
                    passFlag = false;
                  }
                });
                if (!passFlag) {
                  return;
                }
              }
            }
            const params = {
              SEND_DAY: date(this.addForm.SEND_DAY, '%F'),
              TC_ID: this.addForm.customer,
              PROJECT_ID: this.addForm.project,
              DK_ID: this.addForm.dkId,
            };
            if (this.addForm.COMMENT) {
              params.COMMENT = this.addForm.COMMENT;
            }
            addOrderFun(params).then((result) => {
              this.$message.show({ text: '新增成功', type: 'success' });
              this.addFormVisible = false;
              sessionStorage.setItem('orderId', result[0].ID);
              sessionStorage.setItem('orderCode', result[0].ORDER_CODE);
              sessionStorage.setItem('customerId', this.addForm.customer);
              sessionStorage.setItem('projectId', this.addForm.project);
              sessionStorage.setItem('dkID', this.addForm.dkId);
              sessionStorage.setItem('send_day', this.addForm.SEND_DAY);
              sessionStorage.setItem('CAN_MODIFY_PRICE', result[0].CAN_MODIFY_PRICE);
              this.$router.push({ path: '/addOrder/detail' });
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
          } else {
            // -------------------------------------复制订单
            const params = {
              TC_ID: this.addForm.customer,
              PROJECT_ID: this.addForm.project,
              SEND_DAY: date(this.addForm.SEND_DAY, '%F'),
              ORDER_ID: this.addForm.ORDER_ID,
              DK_ID: this.addForm.dkId,
            };
            copyOrderFun(params).then((result) => {
              this.$message.show({ text: '复制订单成功', type: 'success' });
              this.addFormVisible = false;
              this.queryTable();
              this.addFormVisible = false;
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
          }
        } finally { }
      }
    },
    // -------------------------------------选择客户
    queryCustomer () {
      getEnteyCusFun().then((result) => {
        if (result.length !== 0) {
          const list = [...new Set(result.map((item) => JSON.stringify(item)))].map((item) => JSON.parse(item));
          this.companys = list;
          this.customers = list;
        } else {
          this.companys = [];
          this.customers = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getDate () {
      const day = new Date();
      day.setTime(day.getTime() + 24 * 60 * 60 * 1000);
      const s = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
      this.addForm.SEND_DAY = s;
    },
    // -----------------------------------选择项目点
    queryProject (event) {
      this.$set(this.addForm, 'project', '');
      this.$set(this.addForm, 'dkId', '');
      const paramsProject = {
        TC_ID: this.addForm.customer,
      };
      selectProjectFun(paramsProject).then((result) => {
        if (result[0]) {
          this.projects = [...new Set(result[0].list.map((item) => JSON.stringify(item)))].map((item) => JSON.parse(item));
        } else {
          this.projects = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // --------------------客户改变触发
    filterProjects () {
      this.searchForm.project = '';
      if (this.searchForm.TC_COMPANY) {
        this.allProjects = this.allProjectsCopy.filter((item) => item.TC_ID === this.searchForm.TC_COMPANY);
      } else {
        this.allProjects = [...this.allProjectsCopy];
      }
    },
    // 选取项目点 触发团餐公司
    querydkList () {
      this.searchForm.dkName = ''; // 更改项目点时 将档口置空
      if (this.searchForm.project) {
        this.searchForm.TC_COMPANY = this.companys.find((item) => item.ID === this.allProjects.find((project) => project.PROJECT_ID === this.searchForm.project).TC_ID).ID;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.project) {
        params.PROJECT_ID = this.searchForm.project;
      } else {
        this.dk_List = [];
        return false;
      }
      http.post(params).then((result) => {
        this.dk_List = result;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // ----------------------------------------------下拉框获取档口名称
    queryAllProject () {
      const paramsProject = {};
      haveXMDFun(paramsProject).then((result) => {
        if (result[0]) {
          this.allProjects = this.$util.listRemoveDuplicates(result[0].project);
          this.allProjectsCopy = [...this.allProjects];
        } else {
          this.allProjects = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ------------------------------选择档口
    queryDK (event) {
      this.$set(this.addForm, 'dkId', '');
      const params = {
        STATUS: 1,
      };
      if (this.addForm.project) {
        params.PROJECT_ID = this.addForm.project;
      }
      selectDKFun(params).then((res) => {
        this.dkList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    doQueryTable () {
      this.currentPage = 1;
      this.queryTable();
    },
    // -------------------------------------进入页面拉取数据
    queryTable () {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        IS_GET_SLAVE_ORDER: 1,
      };
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = date(this.searchForm.SEND_DAY, '%F');
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.project) {
        params.PROJECT_ID = this.searchForm.project;
      }
      if (this.searchForm.dkName) {
        params.DK_ID = this.searchForm.dkName;
      }
      if (this.searchForm.ORDER_LIST_COMMENT) {
        params.ORDER_LIST_COMMENT = this.searchForm.ORDER_LIST_COMMENT;
      }
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }

      this.loadSearch = true;
      chooseTCFun(params).then((result) => {
        this.tableData = result[0].list;
        this.totalCount = result[0].TOTAL_COUNT;
        this.$store.dispatch('SET_ENTRY_SEARCH_DATA_CONDITION', {
          CONDITION: this.searchForm,
          DATA: this.tableData,
          TOTAL_COUNT: this.totalCount,
          CURRENT_PAGE: this.currentPage,
        });
        this.loadSearch = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loadSearch = false;
      });
    },
    // ----------------------------确认打印
    submitPrint (row) {
      // this.$router.push({ name: 'firstOrderPrint' });
      sessionStorage.setItem('entrySendFlag', 0);
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('tableData', JSON.stringify(this.tableData));
      sessionStorage.setItem('searchForm', JSON.stringify(this.searchForm));
      // 打印流程跳转前备份筛选记忆，供打印页整页刷新后恢复 vuex
      this.$store.dispatch('backupFilterMemory');
      sessionStorage.setItem('countFlag', 0);
      sessionStorage.setItem('sinceStatus', 1);
      sessionStorage.setItem('TEM_TCID', row.TC_ID);
      sessionStorage.setItem('NEED_TCNAME', row.TC_NAME);
      this.queryForm(row.TC_ID);
    },
    queryForm (TC_ID) {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        IS_SUPPLIER_CLIENT: 0,
        TC_ID,
      };
      http.post(params).then((result) => {
        if (result[0].USE_PRINT_TEMPLATE == 1) {
          if (result[0].TEMPLATE_CONTENT && result[0].TEMPLATE_CONTENT.length !== 0 && result[0].TEMPLATE_CONTENT[0].tableSet.includes('生产日期(线上填写)')) this.productionDateDialog = true;
          else this.$router.push({ name: 'sellOrderCustomPrintDetail' });
        } else {
          this.$router.push({ name: 'firstOrderPrint' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    confirmProductionDate () {
      sessionStorage.setItem('未签收销售单打印 生产日期(线上填写)', this.productionDateForm.PRODUCTION_DATE);
      this.productionDateDialog = false;
      this.$router.push({ name: 'sellOrderCustomPrintDetail' });
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryTable();
    },
    // -----------------查看
    detail (row) {
      this.$router.push({ path: '/addOrder/detail' });
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('orderCode', row.ORDER_CODE);
      sessionStorage.setItem('customerId', row.TC_ID);
      sessionStorage.setItem('projectId', row.PROJECT_ID);
      sessionStorage.setItem('send_day', row.SEND_DAY);
      sessionStorage.setItem('TC_NAME', row.TC_NAME);
      sessionStorage.setItem('PROJECT_NAME', row.PROJECT_NAME);
      sessionStorage.setItem('DK_NAME', row.DK_NAME);
      sessionStorage.setItem('CAN_MODIFY_PRICE', row.CAN_MODIFY_PRICE);
    },
    // ----------------------------删除
    deleteOrder (row) {
      this.$confirm('确定删除此订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          ORDER_ID: row.ORDER_ID,
        };
        deleteOrderFun(params).then((result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消删除' });
      });
    },
    // ----------------------导出
    output (row, type) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: row.ORDER_ID,
            iOrder: type,
          };

          printOrderFun(params).then((result) => {
            window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    handleSelectionChange (val) {
      this.checkedArray = val.map(({
        ORDER_ID, SEND_DAY: SEND_DATE, TC_NAME, PROJECT_NAME, DK_NAME,
      }) => ({
        ORDER_ID, SEND_DATE, TC_NAME, PROJECT_NAME, DK_NAME,
      }));
    },
    打开一键导出模态框 () {
      this.一键导出模态框 = true;
    },
    // 一键导出订单
    exportallOrder () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10004',
            OTYPE: 37,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            ORDER_BY: this.一键导出表单.选择类型,
          };
          if (this.searchForm.TC_COMPANY) {
            params.TC_ID = this.searchForm.TC_COMPANY;
          }
          if (this.searchForm.SEND_DAY) {
            params.SEND_DAY = date(this.searchForm.SEND_DAY, '%F');
          }
          if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
            params.START_DAY = this.searchForm.DAY_INTERVAL[0];
            params.END_DAY = this.searchForm.DAY_INTERVAL[1];
          }
          if (this.searchForm.project) {
            params.PROJECT_ID = this.searchForm.project;
          }
          if (this.searchForm.dkName) {
            params.DK_ID = this.searchForm.dkName;
          }
          http.post(params).then((result) => {
            window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    // 发起订单
    launchOrder (row) {
      const order_ids = [];
      order_ids.push(row.ORDER_ID);
      const params = {
        ORDER_IDS: order_ids,
      };
      bulkLaunch(params).then((result) => {
        this.queryTable();
        this.$message.show({ text: '操作成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 批量发起
    bulkLaunchAllOrder () {
      if (this.checkedArray.length !== 0) {
        this.tmpOrderId = [];
        this.checkedArray.forEach((item, index) => {
          this.tmpOrderId.push(item.ORDER_ID);
        });
        this.submitArr = this.tmpOrderId.filter((ele, index, self) => self.indexOf(ele) === index);
        const params = {
          ORDER_IDS: this.submitArr,
        };
        bulkLaunch(params).then((result) => {
          this.queryTable();
          this.$message.show({ text: '操作成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请选择订单', type: 'warning' });
      }
    },
    chooseDate (e) {
      this.addForm.SEND_DAY = e;
    },
    exportCheck (row) {
      const params = {
        ORDER_ID: row.ORDER_ID,
      };
      exportCheckFun(params).then((result) => {
        this.$message.show({ text: '导出成功', type: 'success' });
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 修改订单日期
    editDate (row) {
      // this.sendDate = row.SEND_DAY;
      this.orderId = row.ORDER_ID;
      this.ORDER_CODE = row.ORDER_CODE;
      this.editDateVisible = true;
    },
    // 提交修改订单日期
    editDateSubmit () {
      if (!this.editDateForm.SEND_DAY) {
        this.$message.show({ text: '请选择修改时间', type: 'warning' });
        return;
      }
      // 关账限制
      if (this.$util.isOrderClosed(this.editDateForm.SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法修改为此日期', type: 'warning' });
        return false;
      }
      const params = {
        ORDER_ID: this.orderId,
        ORDER_CODE: this.ORDER_CODE,
        SEND_DAY: this.editDateForm.SEND_DAY,
      };
      editDate(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.queryTable();
        this.editDateVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.editDateVisible = false;
      });
    },
    // ----------------------------确认打印
    printBySequence (row) {
      this.payableFormVisible = true;
      // this.$router.push({ name: 'selfOrderPrintBySequence' });
      sessionStorage.setItem('entrySendFlag', 0);
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('tableData', JSON.stringify(this.tableData));
      sessionStorage.setItem('searchForm', JSON.stringify(this.searchForm));
      sessionStorage.setItem('countFlag', 0);
      sessionStorage.setItem('sinceStatus', 1);
      sessionStorage.setItem('TEM_TCID', row.TC_ID);
    },
    submitPayable () {
      // 打印流程跳转前备份筛选记忆，供打印页整页刷新后恢复 vuex
      this.$store.dispatch('backupFilterMemory');
      this.$router.push({ name: 'selfOrderPrintBySequence', query: { isShortDocFlag: this.payableForm.TYPE } });
    },


    launchToDelivery () {
      this.deliveryList = [];
      this.queryData();
    },
    // 页面加载时请求的数据
    async queryData () {
      const errorList = [];
      this.tempObj = {};
      this.notEnoughList = [];
      this.overList = [];
      for (const {
        ORDER_ID, SEND_DATE, TC_NAME, PROJECT_NAME, DK_NAME,
      } of this.checkedArray) {
        try {
          const res = await stockOutDetailFun({ ORDER_ID });
          if (res.length) {
            const tempList = [];
            for (const [index, item] of res.entries()) {
              const {
                WAREHOUSE_DETAIL_ID, WAREHOUSE_PRODUCT_CODE: PRODUCT_CODE, INW_COUNT, LACK_COUNT, NEED_COUNT, ID,
              } = item;
              if (this.tempObj[PRODUCT_CODE]) {
                if (!tempList.includes(PRODUCT_CODE)) {
                  this.tempObj[PRODUCT_CODE].NEED_COUNT += NEED_COUNT;
                  tempList.push(PRODUCT_CODE);
                }
                if (this.tempObj[PRODUCT_CODE].DETAIL[WAREHOUSE_DETAIL_ID]) {
                  const difference = this.tempObj[PRODUCT_CODE].DETAIL[WAREHOUSE_DETAIL_ID].INW_COUNT - this.tempObj[PRODUCT_CODE].DETAIL[WAREHOUSE_DETAIL_ID].LACK_COUNT;
                  if ((this.tempObj[PRODUCT_CODE].DETAIL[WAREHOUSE_DETAIL_ID].INW_COUNT - this.tempObj[PRODUCT_CODE].DETAIL[WAREHOUSE_DETAIL_ID].LACK_COUNT) < LACK_COUNT) {
                    res[index].LACK_COUNT = difference > 0 ? difference : 0;
                  } else {
                    const deliveryCount = NEED_COUNT - res.slice(0, index)
                      .reduce((total, { WAREHOUSE_PRODUCT_CODE, LACK_COUNT: lc }) => total += (WAREHOUSE_PRODUCT_CODE == PRODUCT_CODE ? Number(lc) : 0), 0);

                    const remainingCount = difference > 0 ? difference : 0;
                    res[index].LACK_COUNT = deliveryCount > remainingCount ? remainingCount : deliveryCount;
                  }
                  this.tempObj[PRODUCT_CODE].LACK_COUNT += res[index].LACK_COUNT;
                  this.tempObj[PRODUCT_CODE].DETAIL[WAREHOUSE_DETAIL_ID].LACK_COUNT += LACK_COUNT;
                } else {
                  this.tempObj[PRODUCT_CODE].DETAIL[WAREHOUSE_DETAIL_ID] = { INW_COUNT, LACK_COUNT };
                }
              } else {
                this.tempObj[PRODUCT_CODE] = {
                  PRODUCT_CODE, NEED_COUNT, DETAIL: {},
                };
                this.tempObj[PRODUCT_CODE].DETAIL[WAREHOUSE_DETAIL_ID] = { INW_COUNT, LACK_COUNT };
                this.tempObj[PRODUCT_CODE].LACK_COUNT = LACK_COUNT;
              }
              if (this.notEnoughList.includes(PRODUCT_CODE)) {
                item.ENOUGH_FLAG = 0;
              } else {
                if (this.tempObj[PRODUCT_CODE].NEED_COUNT > res.filter(({ ID: id }) => id == ID).reduce((total, curr) => total += curr.INW_COUNT, 0)) {
                  item.ENOUGH_FLAG = 0;
                  this.notEnoughList.push(PRODUCT_CODE);
                }
              }
            }
            this.deliveryList.push({
              LIST: res.map((item) => ({ ...item, NEW_TYPE_UNIT: item.TYPE_UNIT, PLACE_LACK_COUNT: item.LACK_COUNT })),
              ORDER_ID,
              SEND_DATE,
              TITLE: `订单ID：${ORDER_ID} 订单日期：${SEND_DATE} 客户：${TC_NAME} 项目点：${PROJECT_NAME} 档口：${DK_NAME}`,
            });
          }
        } catch (err) {
          errorList.push(err);
        }
        // eslint-disable-next-line no-console
        if (errorList.length) console.log(errorList);
      }
      this.rowspan();
      this.deliveryCollapse = [...Array(this.deliveryList.length).keys()];
      this.deliveryDialog = true;
    },
    rowspan () {
      this.spanArr = [];
      for (const [INDEX, { LIST }] of this.deliveryList.entries()) {
        this.spanArr[INDEX] = [];
        LIST.forEach((item, index) => {
          if (index === 0) {
            this.spanArr[INDEX].push(1);
            this.position = 0;
          } else if (LIST[index].ID === LIST[index - 1].ID) {
            this.spanArr[INDEX][this.position] += 1;
            this.spanArr[INDEX].push(0);
          } else {
            this.spanArr[INDEX].push(1);
            this.position = index;
          }
        });
      }
    },
    // ---------------------------------表格合并行
    objectSpanMethod ({
      row, column, rowIndex, columnIndex,
    }, index) {
      if (columnIndex === 0) {
        const _row = this.spanArr[index][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 1) {
        const _row = this.spanArr[index][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 2) {
        const _row = this.spanArr[index][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 3) {
        const _row = this.spanArr[index][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 4) {
        const _row = this.spanArr[index][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (this.WAREHOUSE_MODE == 2 ? columnIndex === 14 : columnIndex === 13) {
        const _row = this.spanArr[index][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    setOutBackgroundColor ({
      row, column, rowIndex, columnIndex,
    }) {
      const indexArry = this.WAREHOUSE_MODE ? [5, 6, 7, 8, 9, 10, 11, 12] : [5, 6, 7, 8, 9, 10, 11];
      if (indexArry.includes(columnIndex)) {
        if (row.LACK_COUNT && row.ORDER_REAL_PRICE < row.PRODUCT_PRICE) {
          return { backgroundColor: '#FDE2E2' };
        }
      }
      return {};
    },
    $_setFontColor (number) {
      return setOutFontColor(Number(number));
    },
    submitLaunchToDelivery () {
      this.outOfStockList = [];


      let text = '';
      const pass = this.deliveryList.map(({ LIST }) => LIST).flat()
        .filter(({ WAREHOUSE_DETAIL_ID }) => WAREHOUSE_DETAIL_ID)
        .every((item) => {
          text = this.checkDeliveryCountFailed(item);
          return !text;
        });

      if (!pass) {
        this.$message.show({ text, type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10177',
        OTYPE: 35,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        DATA_LIST: this.deliveryList.map(({ ORDER_ID, LIST }) => ({
          ORDER_ID,
          PRODUCT_ARRAY: LIST.map((item) => ({ ...item, DELIVER_COUNT: item.LACK_COUNT })).filter(({ DELIVER_COUNT }) => DELIVER_COUNT != 0),
        })),
        WAREHOUSE_MODE: Number(sessionStorage.getItem('WAREHOUSE_MODE')),
      };
      http.post(params).then((res) => {
        let errorList = [];
        let outOfStockList = [];
        if (res[0]) {
          outOfStockList = res[0].STOCK_OUT_LIST || [];
          errorList = res[0].ERROR_LIST || [];
        }
        if (outOfStockList.length) {
          const tmpObj = {};
          for (const item of outOfStockList) {
            if (tmpObj[item.SEND_DATE]) {
              tmpObj[item.SEND_DATE].LIST.push(item);
            } else {
              tmpObj[item.SEND_DATE] = {
                SEND_DATE: item.SEND_DATE,
                SALES_SEND_DATE: item.SEND_DATE,
                LIST: [item],
              };
            }
          }
          this.outOfStockList = Object.values(tmpObj);
          this.purchaseCollapse = [...Array(this.outOfStockList.length).keys()];
          this.outOfStockDialog = true;
        }
        if (errorList.length) {
          let warningText = '以下订单发起失败:';
          for (const err of errorList) {
            warningText += `订单ID${err.ORDER_ID}:${err.REASON},`;
          }
          this.$message.show({ text: warningText.substring(0, warningText.length - 1), type: 'warning' });
        } else {
          this.$message.show({ text: '发起成功', type: 'success' });
          this.deliveryDialog = false;
        }
        this.queryTable();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    submitPurchase () {
      showFullScreenLoading();
      const text = [];
      const pass = this.outOfStockList.map(({ LIST }) => LIST).flat().every((item) => {
        if (this.checkPurchaseCountFailed(item)) {
          text.push(this.checkPurchaseCountFailed(item));
        }
        if (this.checkPurchasePriceFailed(item)) {
          text.push(this.checkPurchasePriceFailed(item));
        }
        if (!item.SUPPLIER_ID) {
          text.push('必须选择供应商');
        }
        return !text.length;
      });

      if (!pass) {
        this.$message.show({ text: text.join(','), type: 'warning' });
        tryHideFullScreenLoading();
        return;
      }
      const tmpObj = {};
      for (const item of this.outOfStockList) {
        for (const detail of item.LIST) {
          if (Number(detail.PURCHASE_COUNT)) {
            if (tmpObj[`${item.SEND_DATE},${detail.SUPPLIER_ID}`]) {
              tmpObj[`${item.SEND_DATE},${detail.SUPPLIER_ID}`].LIST.push(detail);
            } else {
              tmpObj[`${item.SEND_DATE},${detail.SUPPLIER_ID}`] = {
                SEND_DATE: item.SEND_DATE,
                SUPPLIER_ID: detail.SUPPLIER_ID,
                LIST: [detail],
              };
            }
          }
        }
      }
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 56,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_LIST: Object.values(tmpObj),
      };
      http.post(params).then((res) => {
        if (res[0] && res[0].ERROR_LIST) {
          let warningText = '以下订单生成失败:';
          for (const { SUPPLIER_DATE, REASON } of res[0].ERROR_LIST) {
            warningText += `供应商:${SUPPLIER_DATE.split('+')[0]},日期:${SUPPLIER_DATE.split('+')[1]},${REASON};`;
          }
          this.$message.show({ text: warningText.substring(0, warningText.length - 1), type: 'warning' });
        } else {
          this.$message.show({ text: '采购单生成成功', type: 'success' });
        }
        this.deliveryDialog = false;
        this.outOfStockDialog = false;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      }).finally(() => {
        tryHideFullScreenLoading();
      });
    },
    onDeliveryBlur (row) {
      const text = this.checkDeliveryCountFailed(row);
      if (text) {
        this.$message.show({ text, type: 'warning' });
      }
    },
    checkDeliveryCountFailed ({
      WAREHOUSE_DETAIL_ID, WAREHOUSE_PRODUCT_CODE: PRODUCT_CODE, LACK_COUNT, INW_COUNT, NEW_TYPE_UNIT,
    }) {
      if (util.JudgmentUnit(NEW_TYPE_UNIT)) {
        if (!validation.数量正数0验证(LACK_COUNT)) {
          return '出库数量必须为正数';
        }
      } else {
        if (!validation.数量整数正数0验证(LACK_COUNT)) {
          return '出库数量必须为正整数';
        }
      }
      if (LACK_COUNT > INW_COUNT) {
        return '出库数量不能大于库存数量';
      }
      this.overList = [];
      const tempList = this.deliveryList.map(({ LIST }) => LIST).flat();
      if (tempList.reduce((total, { WAREHOUSE_DETAIL_ID: wdi, LACK_COUNT: lc }) => total += (wdi == WAREHOUSE_DETAIL_ID ? lc : 0), 0)
        > this.tempObj[PRODUCT_CODE].DETAIL[WAREHOUSE_DETAIL_ID].INW_COUNT) {
        const tempObj = {};
        for (const item of tempList.filter(({ WAREHOUSE_DETAIL_ID: wdi }) => wdi)) {
          if (tempObj[item.WAREHOUSE_DETAIL_ID]) {
            tempObj[item.WAREHOUSE_DETAIL_ID].LACK_COUNT += item.LACK_COUNT;
          } else {
            tempObj[item.WAREHOUSE_DETAIL_ID] = { ...item };
          }
        }
        this.overList = util.listRemoveDuplicates(Object.values(tempObj).filter(({ LACK_COUNT: lc, INW_COUNT: ic }) => lc > ic)
          .map(({
            WAREHOUSE_PRODUCT_CODE, WAREHOUSE_PRODUCT_NAME, BATCH, PRODUCTION_DATE, LOCATION_CODE,
          }) => ({
            WAREHOUSE_PRODUCT_CODE, WAREHOUSE_PRODUCT_NAME, BATCH, PRODUCTION_DATE, LOCATION_CODE,
          })));
        return '各订单同批次产品总出库数量不能大于库存';
      }
      return '';
    },
    onPurchaseCountBlur ({ PURCHASE_COUNT, TYPE_UNIT }) {
      const text = this.checkPurchaseCountFailed({ PURCHASE_COUNT, TYPE_UNIT });
      if (text) {
        this.$message.show({ text, type: 'warning' });
      }
    },
    checkPurchaseCountFailed ({ PURCHASE_COUNT, TYPE_UNIT }) {
      if (util.JudgmentUnit(TYPE_UNIT)) {
        if (!validation.数量正数0验证(PURCHASE_COUNT)) {
          return '采购数量必须为正数';
        }
      } else {
        if (!validation.数量整数正数0验证(PURCHASE_COUNT)) {
          return '采购数量必须为正整数';
        }
      }
      return '';
    },
    onPurchasePriceBlur ({ PRICE }) {
      const text = this.checkPurchasePriceFailed({ PRICE });
      if (text) {
        this.$message.show({ text, type: 'warning' });
      }
    },
    checkPurchasePriceFailed ({ PRICE }) {
      if (!validation.价格正数0验证(PRICE)) {
        return '单价必须为非负数';
      }
      return '';
    },
    getPurchasePrice (row) {
      const { PRODUCT_CODE, SEND_DATE, SUPPLIER_ID } = row;
      if (SUPPLIER_ID) {
        const params = {
          SERVICE_ID: '10041',
          OTYPE: 37,
          PAGE_SIZE: 1,
          PAGE_INDEX: 0,
          GYS_ID: Number(sessionStorage.getItem('tcId')),
          PRODUCT_CODE,
          START_DAY: SEND_DATE,
          END_DAY: SEND_DATE,
          SUPPLIER_ID,
        };
        http.post(params).then((res) => {
          if (res.length && res[0].LIST && res[0].LIST[0]) {
            row.PRICE = res[0].LIST[0].PRICE;
          } else {
            row.PRICE = 0;
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        row.PRICE = 0;
      }
    },
    importGHOrder () {
      this.importGHOrderDialog = true;
    },
    批量删除 () {
      if (this.checkedArray.length == 0) {
        this.$message.show({ text: '请勾选需要删除的订单', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 8,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: this.checkedArray.map(({ ORDER_ID }) => ORDER_ID),
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    downloadGHOrder () {
      window.location.href = 'https://service.linkda.com.cn/file/templates/高后订单导入模板表.xlsx';
    },
    handleGHOrder () {
      if (this.file_name) {
        const params = {
          SERVICE_ID: '10004',
          OTYPE: 52,
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          FILE_NAME: this.file_name,
          STATUS: -1,
          USE_TC_PRODUCT_CODE: 1,
        };
        http.post(params).then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            this.importGHOrderDialog = false;
            this.queryTable();
          } else {
            this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
        });
      } else {
        this.$message.show({ text: '请点击上传文件', type: 'warning' });
      }
    },
    importOrderWithProductInfo () {
      this.importOrderWithProductInfoDialog = true;
    },
    downloadImportOrderWithProductInfoTemplate () {
      window.open(this.$util.getURLLocalHost('/file/templates/importOrderWithProductInfoTemplate.xls'));
    },
    closeImportOrderWithProductInfo () {
      this.$refs.importOrderWithProductInfoForm.resetFields();
      this.$refs.upload.clearFiles();
      this.importOrderWithProductInfoDialog = false;
    },
    submitImportOrderWithProductInfo () {
      this.$refs.importOrderWithProductInfoForm.validate((valid) => {
        if (valid) {
          const params = {
            SERVICE_ID: '10004',
            OTYPE: 60,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            SEND_DAY: this.importOrderWithProductInfoForm.SEND_DAY,
            FILE_NAME: this.importOrderWithProductInfoForm.fileList[0].response.file_name,
          };
          http.post(params).then((res) => {
            if (res[0] && res[0].error_file_path) {
              window.open(this.$util.getURLLocalHost(res[0].error_file_path));
              this.$message.show({ text: '有错误，请查看错误信息列', type: 'error' });
              this.$refs.upload.clearFiles();
            } else {
              this.$message.show({ text: '导入成功', type: 'success' });
              this.closeImportOrderWithProductInfo();
              this.queryTable();
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.$refs.upload.clearFiles();
          });
        }
      });
    },
    getTableRowClass ({ row, rowIndex }) {
      if (row.PRODUCT_ERROR) {
        return 'product_error_row';
      }
      return '';
    },
  },
};
</script>
<style scoped>
.h4 {
  font-size: 16px !important;
  margin: auto 0;
  cursor: pointer;
}

.el-table>>>.product_error_row {
  background-color: rgb(255, 200, 200);
  /* color: #fff; */
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/entryOrderList.vue